import { render, staticRenderFns } from "./ObjectAttribute.vue?vue&type=template&id=e7461810"
import script from "./ObjectAttribute.vue?vue&type=script&lang=js"
export * from "./ObjectAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports